/** Generic Confirmation Popup */

import classNames from 'classnames';
import { ReactElement } from 'react';
import sharedStyles from '../../styles/Shared.module.css';
import Popup from '../../sharedComponents/TextEditor/components/Popup';

function ConfirmationPopup({
  title,
  description,
  isShow,
  handleBtnClick,
  setIsShow,
  btnLabel,
  btnClassNames,
}: {
    title: string,
    description?: ReactElement,
    isShow: boolean,
    handleBtnClick: () => void,
    setIsShow: (state: boolean) => void,
    btnLabel: string,
    btnClassNames?: string,
}) {
  return (
    <Popup
      width={400}
      height={300}
      open={isShow}
      setopen={setIsShow}
      className="p-6"
    >
      <div className="is-size-6 with-text-color mb-3">
        {title}
      </div>
      <hr className={sharedStyles.hr} />
      {description
      && (
      <div className="is-subtitle with-light-text-color mb-3">
        {description}
      </div>
      )}
      <button
        data-testid="ConfirmationPopup_confirm_button"
        type="button"
        className={classNames(
          'button',
          'has-font-weight-normal',
          'mt-2',
          btnClassNames,
        )}
        onClick={() => {
          handleBtnClick();
          setIsShow(false);
        }}
      >
        {btnLabel}
      </button>
    </Popup>
  );
}

ConfirmationPopup.defaultProps = {
  description: undefined,
  btnClassNames: undefined,
};

export default ConfirmationPopup;
